import { useEffect, useState } from "react";
import { listenToGarmentsBySection } from "../services/garmentService";

export function useGarments(sectionId) {
  const [garments, setGarments] = useState([]);
  const [garmentsLoading, setGarmentsLoading] = useState(true);
  const [garmentsError, setGarmentsError] = useState(null);

  useEffect(() => {
    setGarmentsLoading(true);
    setGarmentsError(null);

    const unsubscribe = listenToGarmentsBySection(
      sectionId,
      (data) => {
        setGarments(data);
        setGarmentsLoading(false);
      },
      (error) => {
        console.error("Unable to load garments:", error);
        setGarmentsError(error);
        setGarmentsLoading(false);
      }
    );

    return unsubscribe;
  }, [sectionId]);

  return {
    garments,
    garmentsLoading,
    garmentsError,
  };
}
